/* tslint:disable */
/* eslint-disable */
/**
 * Performo API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.6.4
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
export function FieldMetadataFromJSON(json) {
    return FieldMetadataFromJSONTyped(json, false);
}
export function FieldMetadataFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'name': !exists(json, 'name') ? undefined : json['name'],
        'type': !exists(json, 'type') ? undefined : json['type'],
        'displayType': !exists(json, 'displayType') ? undefined : json['displayType'],
        'valueList': !exists(json, 'valueList') ? undefined : json['valueList'],
        'global': !exists(json, 'global') ? undefined : json['global'],
        'autoEnter': !exists(json, 'autoEnter') ? undefined : json['autoEnter'],
        'fourDigitYear': !exists(json, 'fourDigitYear') ? undefined : json['fourDigitYear'],
        'maxRepeat': !exists(json, 'maxRepeat') ? undefined : json['maxRepeat'],
        'maxCharacters': !exists(json, 'maxCharacters') ? undefined : json['maxCharacters'],
        'notEmpty': !exists(json, 'notEmpty') ? undefined : json['notEmpty'],
        'numeric': !exists(json, 'numeric') ? undefined : json['numeric'],
        'timeOfDay': !exists(json, 'timeOfDay') ? undefined : json['timeOfDay'],
        'repetitionStart': !exists(json, 'repetitionStart') ? undefined : json['repetitionStart'],
        'repetitionEnd': !exists(json, 'repetitionEnd') ? undefined : json['repetitionEnd'],
    };
}
export function FieldMetadataToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'name': value.name,
        'type': value.type,
        'displayType': value.displayType,
        'valueList': value.valueList,
        'global': value.global,
        'autoEnter': value.autoEnter,
        'fourDigitYear': value.fourDigitYear,
        'maxRepeat': value.maxRepeat,
        'maxCharacters': value.maxCharacters,
        'notEmpty': value.notEmpty,
        'numeric': value.numeric,
        'timeOfDay': value.timeOfDay,
        'repetitionStart': value.repetitionStart,
        'repetitionEnd': value.repetitionEnd,
    };
}
